// extracted by mini-css-extract-plugin
module.exports = {"vertical":"form-input-group_vertical__QQn25","horizontal":"form-input-group_horizontal__2N3gP","largeGap":"form-input-group_largeGap__4GjmR"};